/* eslint-disable no-cond-assign */
import React from 'react';
import { formProps } from '../../Order/Form';
import {
  Type, ProductType, Mode, OrderStatus, OrderPriceType, TimeFrame, CommissionType,
} from '../../../../utils/Order/Order';
import { getTitle } from './reducer';
import { UserType, toDateLocal } from '../../../../utils/Helper';

export const Dispatch = React.createContext(null);

export const initialize = (props) => (initialState) => {
  const type = props.type || props.order.OrderHierarchy || initialState.ui.type;
  const form = props.order.AssetClassForm || initialState.order.AssetClassForm;
  const formDefaults = formProps[form].defaults();

  let CurrentAccount = {};
  if (props.order.CurrentAccount) {
    CurrentAccount = props.order.CurrentAccount;
  }

  let accounts = [];
  if (props.order.Accounts) {
    accounts = props.order.Accounts.map((account, index) => ({ ...account, index }));
  }

  const orderExists = props.order.OrderId > 0;
  const isBasket = orderExists ? props.order.OrderIsBasket : (type == Type.Basket);
  const isBulk = orderExists
    ? (props.order.OrderHasMultipleAccounts && !isBasket) : (type == Type.Bulk);


  const state = {
    ...initialState,
    ui: {
      ...initialState.ui,
      mode: props.mode || initialState.ui.mode,
      type,
      isBasket,
      isBulk,
      userRole: props.userType || initialState.ui.userRole,
      parameters: props.parameters || initialState.ui.parameters,
    },
    order: {
      ...initialState.order,
      ...formDefaults,
      ...props.order,
      CurrentAccount,
      OrderHierarchy: type,
      OrderIsBasket: isBasket,
      OrderHasMultipleAccounts: isBasket || isBulk,
      Accounts: accounts,
    },
    validOffer: true,
  };

  if (orderExists) {
    if (props.order.OrderType == OrderPriceType.MARKETONOPEN || 
        props.order.OrderType == OrderPriceType.MARKETONCLOSE) {
          state.fields.readonly.OrderTimeInForce = true
        }
  }
  state.buttons.confirm.visible = true;
  state.buttons.confirm.label = 'Confirm';
  

  // dialog mode
  if (state.ui.mode === Mode.READONLY) {
    state.buttons.precheck.visible = false;
    state.buttons.save.visible = false;
    state.buttons.confirm.visible = false;

    state.fields = {
      ...state.fields,
      readonly: {},
    };

    Object.keys(state.order).forEach((key) => {
      state.fields.readonly[key] = true;
    });

    Object.keys(state.order.CurrentAccount).forEach((key) => {
      state.fields.readonly[key] = true;
    });

    if (state.wizzard.enabled) {
      state.wizzard.nextBtn.visible = false;
    }

    if ((props.userType == UserType.Trader && props.order.AccountType != 'Customer')
      || state.ui.isBasket) {
      state.fields.hiddens.Commission = true;
      state.fields.hiddens.CommissionType = true;
      state.fields.hiddens.Markup = true;
      state.fields.hiddens.MarkupType = true;
    }

    if (props.userType === UserType.Advisor && state.order.OrderId && state.order.OrderStatus === OrderStatus.AUTH_WAIT) {
      state.order.canResendAuthorizations = true;
    }
  } else if (state.ui.mode === Mode.EDIT) {
    const { order } = props;

    if (props.userType == UserType.Advisor && state.ui.type == Type.Default
      && (!order.OrderId || order.OrderStatus == OrderStatus.PARKED)) {
      state.buttons.save.visible = true;
    }

    if ((props.userType == UserType.Trader && props.order.AccountType != 'Customer')
      || state.ui.isBasket) {
      state.fields.hiddens.Commission = true;
      state.fields.hiddens.CommissionType = true;
      state.fields.hiddens.Markup = true;
      state.fields.hiddens.MarkupType = true;
      state.fields.hiddens.RequiresSpecialCustody = true;
    }
  } else if (state.ui.mode === Mode.EDIT_COMMISSION) {
    const {
      Markup, MarkupType, FXMarkup, FXMarkupType, Commission, CommissionType, ...tmpCurrentAccount
    } = state.order.CurrentAccount;
    Object.keys(tmpCurrentAccount).forEach((f) => {
      state.fields.readonly[f] = true;
    });
    Object.keys(state.order).forEach((f) => {
      state.fields.readonly[f] = true;
    });

    state.buttons.precheck.visible = false;
    state.buttons.confirm.visible = false;
    state.buttons.confirm.label = 'Confirm changes';

    if (state.wizzard.enabled) {
      state.wizzard.nextBtn.visible = false;
      state.wizzard.nextBtn.label = 'Confirm changes';
    }
  } else if (state.ui.mode == Mode.QUOTE) {
    state.fields.readonly.AssetTicker = true;
    state.fields.readonly.OrderPrice = true;
    state.fields.readonly.OrderQuantity = true;
    state.fields.readonly.Quantity = true;
    state.fields.readonly.OrderType = true;
    state.fields.readonly.OrderSide = true;

    state.ui.mode = Mode.EDIT;
    state.ui.quoteId = props.order.quoteId;
  } else if (state.ui.mode === Mode.REALLOCATE) {
    const {
      AccountName, HolderName, Instruction, Markup, MarkupType, FXMarkup, FXMarkupType, Commission,
      CommissionType, ...tmpCurrentAccount
    } = state.order.CurrentAccount;

    // Mark account level fields as read only
    Object.keys(tmpCurrentAccount).forEach((f) => {
      state.fields.readonly[f] = true;
    });

    // Mark order fields as read only
    Object.keys(state.order).forEach((f) => {
      state.fields.readonly[f] = true;
    });
    state.order.CurrentAccountId = state.order.AccountId;
  }

  // title
  state.ui.title = getTitle(state);

  return state;
};

export const defaultState = () => ({
  ui: {
    title: 'New Order',
    mode: Mode.EDIT,
    type: Type.Default,
    userRole: 'Advisor',
    parameters: {},
  },

  buttons: {
    precheck: {
      visible: true,
    },
    modify: {
      visible: false,
    },
    confirm: {
      label: null,
      visible: false,
      loading: false,
      completed: false,
    },
    save: {
      visible: false,
      loading: false,
      completed: false,
    },
  },

  fields: {
    readonly: {},
    errors: {},
    hiddens: {},
  },

  order: {
    AssetClassForm: ProductType.BOND,
    OrderInitDate: toDateLocal(new Date()),
    OrderSide: 'Buy',
    OrderIsSwitch: false,
    OrderType: OrderPriceType.MARKET,
    OrderTimeInForce: TimeFrame.GTC,
    OrderGTD: toDateLocal(new Date()),
    CurrentAccount: {
      CommissionType: CommissionType.PrincipalPercentage,
      MarkupType: CommissionType.FaceValueCash,
      FXMarkupType: CommissionType.FaceValueCash,
      CurrentInfoDate: toDateLocal(new Date()),
    },
  },

  attachments: {},

  entities: {
    settlementCurrencies: null,
  },

  initFetchs: {},

  precheck: {
    authorizations: [],
    histories: [],
  },

  wizzard: {
    enabled: false,
    activeStep: null,
    nextBtn: {
      visible: true,
      loading: false,
      label: '',
    },
    steps: {},
  },
});

const chainedWizzardDefault = () => ({
  enabled: true,
  activeStep: 0,
  nextBtn: {
    visible: true,
    loading: false,
    label: 'Precheck first order',
  },
  steps: {
    0: {
      title: 'Chained step 1: First order',
      nextLabel: 'Precheck first order',
      context: null,
    },
    1: {
      title: 'Chained step 2: Precheck first order',
      nextLabel: 'Confirm and Go to Step 3',
      context: null,
    },
    2: {
      title: 'Chained step 3: Second order',
      nextLabel: 'Precheck second order',
      context: null,
    },
    3: {
      title: 'Chained step 4: Precheck second order',
      nextLabel: 'Confirm chained',
      context: null,
    },
  },
});

const crossWizzardDefault = () => ({
  enabled: true,
  activeStep: 0,
  nextBtn: {
    visible: true,
    loading: false,
    label: 'Precheck first order',
  },
  steps: {
    0: {
      title: 'Cross Step 1: First order',
      nextLabel: 'Precheck first order',
      context: null,
    },
    1: {
      title: 'Cross Step 2: Precheck first order',
      nextLabel: 'Confirm and Go to Step 3',
      context: null,
    },
    2: {
      title: 'Cross Step 3: Second order',
      nextLabel: 'Precheck second order',
      context: null,
    },
    3: {
      title: 'Cross Step 4: Precheck second order',
      nextLabel: 'Confirm cross',
      context: null,
    },
  },
});
